import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";
import { useStaffLayout } from "../../../Components/Context/CandidateLayoutContext";

function BranchList({ isAdmin }) {
  const navigate = useNavigate();

  const { privilegeData } = useStaffLayout();

  function hasbranchAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName.toLowerCase().includes("branch");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasbranchEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName.toLowerCase().includes("branch");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }
  const columns = [
    { field: "BL_Id", label: "#" },
    { field: "BL_Name", label: "Branch" },
    { field: "BL_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();

  const actions = [
    hasbranchEditprivilege(privilegeData) && {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.BL_Id));

        navigate(`/BranchLookup/Edit/${encrypted}?${searchParams.toString()}`);
      },
      color: "warning",
    },
  ].filter(Boolean);
  return (
    <DynamicTable
      columns={columns}
      dataAPI={`/Branch/list`}
      actions={actions}
      title={`Branch`}
      {...(hasbranchAddprivilege(privilegeData) && {
        linkvalue: `/BranchLookup/Add?${searchParams.toString()}`,
      })}
    />
  );
}

export default BranchList;
